import React, { Component, Fragment } from 'react';
import { withRouter } from '#/renderer/router';
import { inject } from 'mobx-react';
import $ from 'jquery';

import { getConfigHome } from '~/store/Query/api';
import UI from './MacroCategoriesGrid.ui';

class MacroCategoriesGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renovaciones: null,
      metaTagsConfig: {
        show: false,
        title: null,
        description: null,
      },
      categories: [],
      faceFilterAsSubmenu: {},
    };

    this.toggleSelected = this.toggleSelected.bind(this);
  }

  componentDidMount() {
    document.getElementById('initial').scrollIntoView(true);
    this.init();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.init();
    }
    if (prevProps.hardCodePath !== this.props.hardCodePath) {
      this.init();
    }
  }

  getAllCategories() {
    return this.props.navigationStore.getCategories().then((res) => {
      res.data.data.sort((prev, current) =>
        prev.locales[process.env.NEXT_PUBLIC_LOCALE].position > current.locales[process.env.NEXT_PUBLIC_LOCALE].position
          ? 1
          : -1,
      );
      return res.data;
    });
  }

  getMacroCategories = async () => {
    const res = await this.props.navigationStore.getMacroCategories();
    this.state.macroCategories = res.data;
  };

  init = async () => {
    const pathnameOrig = this.props.location.pathname;
    const pathname = this.props.hardCodePath ? this.props.hardCodePath : pathnameOrig;
    const path = pathname.match(/\/categories\/(.+)/);

    let found = true;
    // const { history } = this.props;
    // this.productList();
    const [cats, config, home] = await Promise.all([
      this.getAllCategories(),
      this.props.orderStore.getConfig(),
      getConfigHome(),
      this.getMacroCategories(),
    ]);

    this.setState({ categories: cats.data });

    if (path) {
      const cat = cats.data.find((c) => c.external_referrer === path[1]);
      if (cat) {
        this.state.showMacro = false;
        this.state.contract = cat.contract;
        this.state.keywords = cat.locales[process.env.NEXT_PUBLIC_LOCALE].seo.keywords;
        this.state.name = cat.locales[process.env.NEXT_PUBLIC_LOCALE].name;
        //console.log('contract', cat.contract);

        const faceFilterAsSubmenu = config?.data?.data?.facet_filter_as_submenu_config ?? {};
        this.setState({ faceFilterAsSubmenu, categorySlug: cat.external_referrer });
      } else {
        found = false;
      }
    }
    if (found) {
      if (config.success && config.data.data && config.data.data.renovaciones && config.data.data.renovaciones.activo
      && home.ok && home.body?.renovaciones) {
        this.setState({
          renovaciones: {
            texto: config.data.data.renovaciones.texto,
            link: home.body.renovaciones.link,
          }
        });
      }
    } else {
      this.props.history.push('/not-found');
    }
  };

  toggleSelected(selected) {
    const $selected = $(`#${selected}`);
    if (!$selected.hasClass('active')) {
      $('.nav--category-box').removeClass('active');
      $selected.addClass('active');
    }
  }

  render() {
    return (
      <Fragment>
        <UI
          macroCategories={this.state.macroCategories}
          toggleSelected={this.toggleSelected}
          renovaciones={this.state.renovaciones}
          categorySlug={this.state.categorySlug}
          categories={this.state.categories}
          faceFilterAsSubmenu={this.state.faceFilterAsSubmenu}
        />
      </Fragment>
    );
  }
}

export default inject('navigationStore', 'orderStore')(withRouter(MacroCategoriesGrid));
